import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { cookie } from 'utils/cookies/cookies';
import { apiService, getHeaders, url } from 'utils/api';
import { getFCMToken } from '../../firebase';
import Button from 'components/inputs/Button';

const Loginas = (props) => {
  const { showLoader } = props;
  const [isProcessing, setIsProcessing] = useState(false);
  const [email, setEmail] = useState(null);

  useEffect(() => {
    const { token, role, refreshtoken, email: emailParam } = qs.parse(props.location.search, { ignoreQueryPrefix: true });
    token && cookie.set('token', token);
    role && cookie.set('user-role', role);
    refreshtoken && cookie.set('refreshToken', refreshtoken);
    
    // Decode and log email from SSO response
    if (emailParam) {
      const decodedEmail = decodeURIComponent(emailParam);
      console.log('SSO Email:', decodedEmail);
      setEmail(decodedEmail);
    }
  }, []);

  const openPage = () => {
    if (cookie.get('user-role') === 'super_admin') {
      setTimeout(() => {
        window.location.href = '/tenantAdmin';
      }, 1000);
    } else if (cookie.get('user-role') === 'support') {
      setTimeout(() => {
        window.location.href = '/chargerStatus';
      }, 1000);
    } else {
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1000);
    }
  };

  const sendFCMTokenToServer = async () => {
    setIsProcessing(true);
    try {
      const fcmToken = await getFCMToken();
      if (fcmToken) {
        const params = { web_token: fcmToken };
        try {
          await apiService.post(url('/util/savetoken', params), params, {
            headers: getHeaders(true),
          });
          //console.log('FCM Token Saved');
        } catch (error) {
          //console.log('Getting error while saving fcmToken');
        } finally {
          openPage();
        }
      } else {
        //console.log('No registration token available. Request permission to generate one.');
        openPage();
      }
    } catch (error) {
      //console.log('Getting error while retrieving fcmToken');
      openPage();
    }
  };

  const handleCPMSClick = () => {
    sendFCMTokenToServer();
  };

  const handleCMMSClick = () => {
    const cmmsUrl = process.env.REACT_APP_CMMS_URL || '';
    console.log('CMMS URL:', cmmsUrl);
    console.log('Email:', email);
    window.location.href = `${cmmsUrl}auth/sso/callback?email=${email}`;
  };

  return (
    <>
      {showLoader || isProcessing ? (
        <div className="profile-loader--block">
          <div className="spinner-border text-danger" />
        </div>
      ) : (
        <div className="login-page__main">
          <div className="login-bg-block">
            <div className="login-content-block">
              <div className="page-block__main">
                <div className="title">Select System</div>
                <p className="sub-title">Choose a system to continue</p>
                <div className="login-form__block">
                  <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center' }} className="login-button--block">
                    <Button type="button" onClick={handleCPMSClick} className="login--btn" style={{ width: '100%', maxWidth: '300px' }}>
                      CPMS
                    </Button>
                    <Button type="button" onClick={handleCMMSClick} className="login--btn" style={{ width: '100%', maxWidth: '300px' }}>
                      CMMS
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
Loginas.propTypes = {
  location: PropTypes.object,
  showLoader: PropTypes.bool,
};
export default Loginas;
